// Taxi Driver Component
import React, { useRef, useState, useEffect } from "react";
import { Navbar, Button } from "flowbite-react";
import { HiArrowLeft } from "react-icons/hi2";
import taxiDriverSvg from "../../../img/taxi-driver-id.svg";
import { FaCamera } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { handleLoadTaxiDriverId, handleTaxiDriverIdUpload } from "./handler" ;
import { MdCheckCircle } from "react-icons/md";
import { BsThreeDots } from "react-icons/bs";

const TaxiDriverIdComponent = (props) => {
  const cssForImageCard = {
    success : {
      imageDiv: 'mt-2 mb-10 custom-card-success border rounded-md items-center shadow-none p-10',
    },
    standard : {
      imageDiv: 'mt-2 mb-10 custom-card border rounded-md items-center shadow-none p-10',
    }
  }

  const taxiDriverIdRef = useRef(null);
  const selectedProfileType = JSON.parse(sessionStorage.getItem("selectedProfileType"));

  const navigate = useNavigate();
  // let [phvDecalPic, setPhvDecalPic] = useState();
  let [taxiDriverIdPic, setTaxiDriverIdPic] = useState();
  // let [userUploadedPhvDecalPic, setUserUploadedPhvDecalPic] = useState(false)
  let [userUploadedTaxiDriverPic, setUserUploadedTaxiDriverPic] = useState(false)
  // let [phvDecalPicLoading, setPhvDecalPicLoading] = useState(false)
  let [taxiDriverPicLoading, setTaxiDriverPicLoading] = useState(false)
  let [validationOnSubmit, setValidationOnSubmit] = useState(false)
  let [showButton, setShowButton] = useState(false)
  let [validation, setValidation] = useState({
    show: false,
    message: "",
    class: "",
  });

  useEffect(() => {
    handleLoadTaxiDriverId(props.itemIndex, props.memberRequirement.requiredDocuments,setTaxiDriverIdPic,setUserUploadedTaxiDriverPic,taxiDriverSvg)
  },[])

    return (
      <>
        <Navbar
          fluid={true}
          rounded={true}
          className="shadow mb-3"
          style={{ position: "fixed", width: "100%", top: "0" }}
        >
          <Navbar.Brand
            onClick={() => {
              props.setOpenUploadDocument({
                openDocument: false,
                documentType: "",
              });
            }}
          >
            <HiArrowLeft className="h-10 w-5 ml-2" />
          </Navbar.Brand>
        </Navbar>
        <div className='p-6  max-w-md m-auto' style={{paddingTop:'80px'}}>
          <h5 className="text-2xl mb-2 font-bold tracking-tight text-gray-900 dark:text-white">
          Taxi Driver ID
          </h5>
          {
            validationOnSubmit && 
            <div className="error-msg">
              <span>Need to Vocational License before submitting for verification</span>
            </div>
        }
          { 
          validation.show && 
          <div className="error-msg">
            <span>{validation.message}</span>
          </div>
          }
        {
          userUploadedTaxiDriverPic && 
          <div class="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white" style={{paddingRight: '10px'}}>
            <MdCheckCircle style = {{ color: '#15BE44' }}/>
          </div>
        }
          <label className='font-bold tracking-tight text-gray-900'>MDT Display</label>
          <div className={ userUploadedTaxiDriverPic ?  cssForImageCard.success.imageDiv : cssForImageCard.standard.imageDiv }>
          {
            validation.show && (
              <div className={validation.class}>
                 <span>{validation.message}</span>
              </div>
            )
          }
              <img src={taxiDriverIdPic}
                  className="w-auto m-auto"
                  alt="Ryde" 
              />
              <p className='text-xs text-gray-400 tracking-tight mt-2'><i>.We accept any of the following: <br/>
                  1. Login to your taxi driver account on your MDT Display. <br/>
                  2. Press 'OP' button on MDT Display to show driver details on MDT Display Screen.<br/>
                  3. Take a photo of driver details on MDT Display.(If you do not have a MDT Display. Please take a photo of your taxi driver ID on your windscreen instead)<br/> 
                  </i></p>
              <Button  pill={true} className='mt-5 m-auto w-sm pr-4' onClick={(e)=>{
                e.preventDefault();
                taxiDriverIdRef.current.click();
            }}>
                 {
                taxiDriverPicLoading ? <BsThreeDots className="h-5 w-10" /> : <FaCamera className="h-5 w-10" />
              }
                  <label // for="file-upload"
                  className="relative cursor-pointer rounded-md font-medium">
                      <span>{taxiDriverPicLoading ? 'Saving' : userUploadedTaxiDriverPic ? 'Replace' : 'Upload' }</span>
                  </label>
              </Button>
              <input 
                  id="file-upload" 
                  name="file-upload"
                  type="file"
                  ref={taxiDriverIdRef}
                  style={{display: 'none', width:'0px'}}
                  onChange={async (event) => {
                    await handleTaxiDriverIdUpload(event, setValidation, setTaxiDriverPicLoading, setUserUploadedTaxiDriverPic,
                      "taxiDriverId", "taxiDriverId", selectedProfileType.profileId, setTaxiDriverIdPic, navigate, props.memberRequirement, props.setMemberRequirement,props.itemIndex);
                      setValidationOnSubmit(false)
                  }}
              />
          </div>
  
          <Button className='bg-primary w-full mt-5' pill={true} disabled={false} 
              onClick={()=>{
                if(userUploadedTaxiDriverPic ) {
                  props.setOpenUploadDocument({
                    openDocument: false,
                    documentType: "",
                  });
                } else {
                  setValidationOnSubmit(true)
                  window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
                }
              }}
          >
              Save
          </Button>
        </div>
      </>
    )
}

export default TaxiDriverIdComponent;